import {SimplePage} from "../../elements/Pages";
import React, {useEffect, useState} from "react";

import {getAbsenceNoticeReasonsAbsencesOnly} from "../../../api/logbook";

import {useQuery} from "@tanstack/react-query";
import ListViewTable, {TableLink} from "../../elements/tables/ListViewTable";
import {getAbsencesReport, getAbsencesReportExcel} from "../../../api/reports";
import {DownloadButton} from "../../elements/Buttons";
import {useSchoolYears} from "../../../contexts/SchoolYearContext";
import SchoolYearFilter from "../../elements/SchoolYearFilter";
import {
    getCancelledProjectsReport,
    getCancelledProjectsReportExcel, getProjectAbsenceReasons,
    getProjectAbsencesReport, getProjectAbsencesReportExcel
} from "../../../api/projects";
import {DocumentCheckIcon} from "@heroicons/react/20/solid";
import {
    getStudierzeitAbsenceReasons,
    getStudierzeitAbsencesReport,
    getStudierzeitAbsencesReportExcel
} from "../../../api/studierzeit";


export default function StudierzeitAbsencesReport() {

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["studierzeit_absences"],
        getStudierzeitAbsencesReport,
        {refetchInterval: 1000 * 60 * 60}
    )

    const {data: reasons} = useQuery(
        ["studierzeit_absence_reasons"],
        getStudierzeitAbsenceReasons,
        {refetchInterval: 1000 * 60 * 60 * 24}
    )

    let columns = [
        {
            accessorKey: "name",
            id: "student",
            header: "SchülerIn",
            // columnType: "student",
            enableColumnFilter: false,
            sortingFn: "lastNameSorting",
        },
    ]

    if (!reasons) return <></>

    // add columns dynamically
    for (var i = 0; i < reasons.length; i++) {
        // console.log(reasons[i])
        columns.push({
            accessorKey: "reasons." + reasons[i].id,
            id: reasons[i].id,
            header: reasons[i].name,
            enableColumnFilter: false
        })
    }

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Studierzeitabwesenheit nach Schülern und Gründen
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <DownloadButton
                            apiFunction={() => getStudierzeitAbsencesReportExcel()}
                            fileName="Studierzeitabwesenheit.xls"
                            label="Excel herunterladen"/>

                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getRowLink={null}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
